import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomepage = location.pathname === '/';
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToSection = (sectionId) => {
    if (isHomepage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/90 backdrop-blur-md' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_reality-bender/artifacts/es2mwale_logo1.png"
              alt="Simon Nomis Logo"
              className="h-8 md:h-10 w-auto"
            />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-purple-400 transition-colors duration-200"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('show')}
              className="text-white hover:text-purple-400 transition-colors duration-200"
            >
              Show
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="text-white hover:text-purple-400 transition-colors duration-200"
            >
              Gallery
            </button>
            <button 
              onClick={() => scrollToSection('tickets')}
              className="text-white hover:text-purple-400 transition-colors duration-200"
            >
              Tickets
            </button>
            <Link 
              to="/articles"
              className="text-white hover:text-purple-400 transition-colors duration-200"
            >
              Articles
            </Link>
            <Link 
              to="/faq"
              className="text-white hover:text-purple-400 transition-colors duration-200"
            >
              FAQ
            </Link>
            <Button 
              onClick={() => scrollToSection('tickets')}
              className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-full transition-all duration-200 transform hover:scale-105"
            >
              Buy Tickets Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white focus:outline-none"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-700">
            <nav className="flex flex-col space-y-4 pt-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-white hover:text-purple-400 transition-colors duration-200 text-left"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('show')}
                className="text-white hover:text-purple-400 transition-colors duration-200 text-left"
              >
                Show
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-white hover:text-purple-400 transition-colors duration-200 text-left"
              >
                Gallery
              </button>
              <button 
                onClick={() => scrollToSection('tickets')}
                className="text-white hover:text-purple-400 transition-colors duration-200 text-left"
              >
                Tickets
              </button>
              <Link 
                to="/articles"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-white hover:text-purple-400 transition-colors duration-200 text-left"
              >
                Articles
              </Link>
              <Link 
                to="/faq"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-white hover:text-purple-400 transition-colors duration-200 text-left"
              >
                FAQ
              </Link>
              <Button 
                onClick={() => scrollToSection('tickets')}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-full transition-all duration-200 w-fit"
              >
                Buy Tickets Now
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;